import { render, staticRenderFns } from "./Portfolios.vue?vue&type=template&id=15b71811&scoped=true"
import script from "./Portfolios.vue?vue&type=script&lang=js"
export * from "./Portfolios.vue?vue&type=script&lang=js"
import style0 from "./Portfolios.vue?vue&type=style&index=0&id=15b71811&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b71811",
  null
  
)

export default component.exports